import { cacheTypes, getMethodByCallBack, postMethodByCallBack, postMethodByDispatcher } from "../../../store/api/CommonFunctions";

export function getHappycallQuestionList(categoryID, onGet) {
    getMethodByCallBack(`api/HappycallAPI/GetHappycallQuestionList?categoryID=${categoryID}`, cacheTypes.NoCache, onGet, "GetHappycallQuestionList");
}
export function saveHappycallResult(data, fn) {
    postMethodByCallBack(`api/HappycallAPI/AddHappycallResult`, data, fn, "AddHappycallResult");
}
export function getHappyCallMetrics(onGet) {
    getMethodByCallBack(`api/HappycallAPI/GetHappyCallMetricList`, cacheTypes.NoCache, onGet, "GetHappyCallMetrics");
}
export function saveHappyCallSettings(data, onSave) {
    postMethodByCallBack(`api/SystemSetting/SaveHappyCallSettings`, data, onSave, "SaveHappyCallSettings");
}
export function getHappyCallCatList(onGet) {
    getMethodByCallBack(`api/HappycallAPI/GetHappyCallCatList`, cacheTypes.NoCache, onGet, "GetHappyCallCatList");
}
export function addEditHappyCallQuestion(data, onDone) {
    postMethodByCallBack('api/HappycallAPI/AddEditHappyCallQuestion', data, onDone, "AddEditHappyCallQuestion");
}
export function getHappyCallQuestion(id, onGet) {
    getMethodByCallBack(`api/HappycallAPI/GetHappyCallQuestion?id=${id}`, cacheTypes.NoCache, onGet, "GetHappyCallQuestion");
}
export function searchServiceForHappyCall(data, onGet) {
    return dispatch => {
        dispatch({
            type: "HAPPY_CALL_SERVICE_FILTER",
            data: data
        })
        dispatch(postMethodByDispatcher(`api/HappycallAPI/SearchServiceForHappyCall`, data, "SEARCH_HAPPY_CALL_SERVICE", "جستجوی سرویس های رضایت سنجی", onGet));
    }
}
export function getHappyCallStatusList(onGet)
{
    getMethodByCallBack(`api/HappycallAPI/GetHappyCallStatusList`, cacheTypes.NoCache, onGet, "GetHappyCallStatusList");
}
export function getHappyCallResult(serviceType, serviceID, onGet)
{
    getMethodByCallBack(`api/HappycallAPI/GetHappyCallResult?serviceType=${serviceType}&serviceID=${serviceID}`, cacheTypes.NoCache, onGet, "GetHappyCallResult");
}
export function changeHappyCallStatus(serviceType, serviceID, happyCallStatus, onChange)
{
    getMethodByCallBack(`api/HappycallAPI/ChangeHappyCallStatus?serviceType=${serviceType}&serviceID=${serviceID}&happyCallStatus=${happyCallStatus}`, cacheTypes.NoCache, onChange, "changeHappyCallStatus");
}